import { ReactNode } from 'react';

function ListPageWrapper({ children }: { children: ReactNode }) {
  return <div className="p-4">{children}</div>;
}

export default ListPageWrapper;
